import { render, staticRenderFns } from "./SlackDownload.vue?vue&type=template&id=51c30c73&scoped=true"
import script from "./SlackDownload.vue?vue&type=script&lang=js"
export * from "./SlackDownload.vue?vue&type=script&lang=js"
import style0 from "./SlackDownload.vue?vue&type=style&index=0&id=51c30c73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c30c73",
  null
  
)

export default component.exports